import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CashMovementsAnalisisService } from '@services/cash-movements.analisis.service';
import { ToastrService } from 'ngx-toastr';
import { LoggerService } from '@services/logger.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { GLOBAL_DATE_FORMATS } from '@/date-picker-formats';
import moment from 'moment';

@Component({
  selector: 'app-dialog-delete-cash-funds',
  templateUrl: './dialog-delete-cash-funds.component.html',
  styleUrls: ['./dialog-delete-cash-funds.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: GLOBAL_DATE_FORMATS },
  ],
})
export class DialogDeleteCashFundsComponent {
  deleteForm: FormGroup;
  loading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DialogDeleteCashFundsComponent>,
    private formBuilder: FormBuilder,
    private cashMovementsAnalysisService: CashMovementsAnalisisService,
    private toastr: ToastrService,
  ) {
    this.deleteForm = this.formBuilder.group({
      data: ['', Validators.required],
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onDelete(): void {
    if (this.deleteForm.valid) {
      this.loading = true;
      const dateValue = this.deleteForm.get('data')?.value;

      // Format the date using moment.js
      let formattedDate: string;
      if (dateValue instanceof Date) {
        formattedDate = moment(dateValue).format('YYYY-MM-DD');
      } else if (moment.isMoment(dateValue)) {
        formattedDate = dateValue.format('YYYY-MM-DD');
      } else if (typeof dateValue === 'string') {
        formattedDate = moment(dateValue).format('YYYY-MM-DD');
      } else {
        formattedDate = moment().format('YYYY-MM-DD');
      }

      this.cashMovementsAnalysisService.deleteCashFunds(formattedDate).subscribe({
        next: () => {
          this.toastr.success('Fondi cassa cancellati correttamente!');
          this.loading = false;
          this.dialogRef.close(true);
        },
        error: (error) => {
          LoggerService.error('deleteCashFunds failed!');
          LoggerService.error(error);
          this.toastr.error('Errore durante la cancellazione dei fondi cassa');
          this.loading = false;
        },
      });
    }
  }
}
